import type { ButtonHTMLAttributes, HTMLAttributes } from 'react';

import './logo.css';

export interface LogoProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  tone?: 'dark' | 'light';
}

interface LogoArtworkProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: 'dark' | 'light';
}

export function LogoArtwork({ className = '', tone = 'dark', ...props }: LogoArtworkProps) {
  return (
    <span {...props} className={['lovo-logo__artwork', `lovo-logo__artwork--${tone}`, className].filter(Boolean).join(' ')}>
      <img src="/figma/assets/lovo-logo-vector.svg" alt="LOVO" style={{ width: '100px', height: '32px', flexShrink: 0, display: 'block' }} />
    </span>
  );
}

export function Logo({ tone = 'dark', className = '', type = 'button', ...props }: LogoProps) {
  return (
    <button
      {...props}
      className={['lovo-logo', className].filter(Boolean).join(' ')}
      data-figma-node={tone === 'dark' ? '33:20105' : '33:20120'}
      data-figma-variant={tone === 'dark' ? 'Property 1=Default' : 'Property 1=Variant2'}
      type={type}
      aria-label={props['aria-label'] ?? 'LOVO'}
    >
      <LogoArtwork tone={tone} />
    </button>
  );
}
